import React from 'react';

import { useNavigate } from 'react-router-dom';

import PohBadge, { BadgeVariant } from '@ui-kit/Badge/Badge';

import { getWorkoutInvitesCountForCurrentUser } from '../@services/workoutsInvites.service';

const WorkoutsInviteCounter: React.FC<{ before?: React.ReactNode; after?: React.ReactNode }> = ({
  before,
  after,
}) => {
  const [count, setCount] = React.useState(0);
  const navigate = useNavigate();
  const run = () => getWorkoutInvitesCountForCurrentUser().then(setCount);
  React.useEffect(() => {
    run();
  }, []);
  return count > 0 ? (
    <>
      {before}
      <PohBadge
        as="small"
        className="ms-1"
        variant={BadgeVariant.Success}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/workouts/invites`);
        }}
        style={{ cursor: 'pointer' }}
      >
        {count}
      </PohBadge>
      {after}
    </>
  ) : null;
};

export default WorkoutsInviteCounter;
